<template>
  <v-card flat :tile="$vuetify.breakpoint.mobile" class="fill-height pt-9 feature-card" v-if="host">
     <app-privacy></app-privacy>
     <v-app-bar dense flat fixed color="white" hide-on-scroll  class="px-0 mx-0" > 
            <!--v-toolbar-title v-text="host.name" class="ml-0 pl-2 font-weight-light"></v-toolbar-title-->
            <div class="mx-auto" :style="`width:${$config.page.width}px`">
            <v-btn text class="font-weight-bold" color="primary" to="/" v-if="allowHome">Home</v-btn>
            <v-btn text class="caption" :to="`/${host._id}`">Bestellen</v-btn>
            <v-btn text class="caption" @click="$vuetify.goTo($refs.footer1)">Contact</v-btn>
            </div>
             
          </v-app-bar>
    <v-img
              :src="host.banner"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="400px"
            >
                     <v-store v-if="actioncode" 
                     :host="host" dark class="mx-auto rounded-xl pa-5 px-3 mx-3" style="background:RGBA(0,0,0,0.7)" 
                     :max-width="400" 
                     :code="actioncode"
                     :title="host.hero"></v-store>
                    <center v-else><v-btn large :to="`/${host._id}`" rounded color="primary" class="mt-5">Direct bestellen</v-btn></center><br>
                     
               
            
              <v-card-title  class="text-h5 mx-auto text-header font-weight-light mt-0" :style="`max-width:${$config.page.width}px`">
                 <v-avatar v-if="host.logo" size="70" class="mr-3"
              style="z-index:10;box-shadow: 0px 7px 8px -4px rgb(0 0 0 / 20%), 0px 13px 19px 2px rgb(0 0 0 / 14%), 0px 5px 24px 4px rgb(0 0 0 / 12%) !important;">
          <v-img :src="host.logo"></v-img>
        </v-avatar>
                {{host.name}}
              </v-card-title>
            </v-img>
   
            <v-tabs v-if="tabindex > -1" v-model="tabindex" class="my-0 mx-auto" grow :show-arrows="false" dense optional active-class="font-weight-bold" :background-color="$vuetify.breakpoint.mobile ? 'primary' : null"
            :style="`max-width:${$config.page.width}px`">
              <v-tab v-for="(tab,i) in tabs" v-text="tab.name" :key="i"
              :class="{'caption' : $vuetify.breakpoint.mobile, 
              'ma-0': $vuetify.breakpoint.mobile, 
              'pa-0': $vuetify.breakpoint.mobile,
              'white--text': $vuetify.breakpoint.mobile,
              }" style="min-width: auto;"
              ></v-tab>
            </v-tabs>
        <template v-if="tabindex>-1 && tabs && tabs[tabindex] && tabs[tabindex].groups">
        <v-sheet v-for="(tab,ii) in [tabs[tabindex]]" :key="'t' + ii" class="mt-15">
          <v-container v-if="tab.groups" :style="`max-width:${$config.page.width}px;`" class="mx-auto" :class="{'cols-2' :!$vuetify.breakpoint.mobile }">
               <template v-for="(group,i) in tab.groups">
                  <v-card-subtitle  class="px-0 primary--text" :style="i==0 ? 'position:absolute;margin-top:-60px': ''" v-text="group" :value="group"  :key="'g' + i"></v-card-subtitle>
                  <v-divider :key="'d' + i"></v-divider>
                     <v-card-text :key="'t' + i" class="px-0">
                       <template v-for="(p,j) in products.filter(p=>p.tab==tab.name && p.group==group)" >
                         <product-item :value="p" :key="'s' + j" class="py-1"></product-item>
                         <v-divider :key="'d' + j"></v-divider>
                        <!--span class="float-right" :key="'s' + i + 'p' + j" >{{product.price | toCurrency}}</span>
                        <div v-text="product.name" :key="'t' + i + 'p' + j" 
                      ></div-->
                       </template>
                      </v-card-text>
                </template>
          </v-container>
        </v-sheet>
      </template>
        <v-sheet v-if="host.feature && host.feature.title">
            <v-container :style="`max-width:${$config.page.width}px`" class="mx-auto">
              <v-row>
              <v-col cols="12" md="6" :order="$vuetify.breakpoint.mobile ? 'first': null">
                <v-card-title class="px-0" v-text="host.feature.title"></v-card-title>
                <v-card-text class="pa-0" v-html="host.feature.description || host.description"></v-card-text>
                <center v-if="allow"><v-btn large :to="`/${host._id}`" color="primary" class="mt-5">Nu bestellen</v-btn></center>
                </v-col>
              <v-col cols="12" md="6" :order="$vuetify.breakpoint.mobile ? 'last': null">
                <v-card-text><v-img class="rounded-xl" :src="host.feature.image" contain max-height="400"></v-img></v-card-text>
                </v-col>
              </v-row>
            </v-container>
        </v-sheet>
        <v-sheet v-if="host.delivery && host.delivery.deliver && !host.stealth" color="#E3F8FF">
            <v-container :style="`max-width:${$config.page.width}px`" class="mx-auto">
              <v-row>
              <v-col cols="12" md="6" :order="$vuetify.breakpoint.mobile ? 'last': null">
                <v-img :src="host.delivery.image || '/img/delivery.png'" class="rounded-xl" contain max-height="400"></v-img>
                </v-col>
              <v-col cols="12" md="6" :order="$vuetify.breakpoint.mobile ? 'first': null">
                <v-card-title class="px-0" >Bezorgen</v-card-title>
                <v-icon class="mr-2" color="primary" large>mdi-truck-delivery-outline</v-icon> <b class="primary--text">{{host.delivery.wait || 45 }} minuten.</b>
                <v-card-text class="pa-0 mt-3" v-html="host.delivery.description || $config.eetplein.delivery.description"></v-card-text>
                
                <v-btn text v-if="!showCost && host.regions && host.regions.length>0" color="primary" class="mt-5" @click="showCost=!showCost">Regio's weergeven</v-btn>
                
                <v-expand-transition>
                  <delivery-cost-card v-if="showCost" v-model="host"></delivery-cost-card>
                </v-expand-transition>
                
                <v-btn text v-if="showCost && host.regions && host.regions.length>0" color="primary" class="mt-5" @click="showCost=!showCost">Verbergen</v-btn>
                <center v-if="allow"><v-btn large :to="`/${host._id}`" color="primary" class="mt-5">Nu bestellen</v-btn></center>
                </v-col>
              </v-row>
            </v-container>
              
        </v-sheet>
          
      <v-sheet v-if="host.order" :color="host.delivery && host.delivery.deliver && !host.stealth ? null : '#E3F8FF'">
            <v-container :style="`max-width:${$config.page.width}px`" class="mx-auto">
              <v-row>
            
              <v-col cols="12" md="6" :order="$vuetify.breakpoint.mobile ? 'first': null">
                <v-card-title class="px-0">Afhalen</v-card-title>
                 <v-icon class="mr-2" color="primary" large>access_time</v-icon> <b class="primary--text">{{host.order.wait || 20 }} minuten.</b>
                <v-card-text  class="pa-0 my-3" v-html="host.order.description || $config.eetplein.order.description"></v-card-text>
                   <a style="text-decoration:none" v-if="host._address"
            target="_blank" :href="`https://www.google.com/maps/search/${host._address.name}`"><v-icon class="mr-2">mdi-map-marker</v-icon>{{host._address.name }}</a>
            <center v-if="allow"><v-btn large :to="`/${host._id}`" color="primary" class="mt-5">Nu bestellen</v-btn></center>
                </v-col>
                 <v-col cols="12" md="6" :order="$vuetify.breakpoint.mobile ? 'last': null">
                <v-img :src="host.order.image || '/img/takeout.png'" class="rounded-xl" contain max-height="400"></v-img>
                </v-col>
              </v-row>
            </v-container>
        </v-sheet>
         <v-sheet v-if="host._discounts && host._discounts.length>0">
            <v-container :style="`max-width:${$config.page.width}px`" class="mx-auto">
              <v-row>
              <v-col cols="12" md="6" ::order="$vuetify.breakpoint.mobile ? 'last': null">
                 <v-img :src="'/img/discount.png'" width="200" height="200" class="mx-auto my-5 rounded-xl"></v-img>
              </v-col>
              <v-col cols="12" md="6" :order="$vuetify.breakpoint.mobile ? 'first': null">
              <discount-table card v-model="host._discounts" show-header></discount-table>
              <center v-if="allow"><v-btn large :to="`/${host._id}`" color="primary" class="mt-5">Nu bestellen</v-btn></center>
              </v-col>
              </v-row>
            </v-container>
         </v-sheet>
         <v-sheet v-if="host.feature1 && host.feature1.title">
            <v-container :style="`max-width:${$config.page.width}px`" class="mx-auto">
              <v-row>
              <v-col cols="12" md="6" :order="$vuetify.breakpoint.mobile ? 'last': null">
                <v-img :src="host.feature1.image" contain max-height="400" class="rounded-xl"></v-img>
                </v-col>
              <v-col cols="12" md="6" :order="$vuetify.breakpoint.mobile ? 'first': null">
                <v-card-title class="px-0" v-text="host.feature1.title"></v-card-title>
                <v-card-text class="pa-0" v-html="host.feature1.description"></v-card-text>
                </v-col>
              
              </v-row>
            </v-container>
        </v-sheet>
   <v-sheet v-if="host.feature2 && host.feature2.title" color="grey lighten-4">
            <v-container :style="`max-width:${$config.page.width}px`" class="mx-auto">
              <v-row>
              <v-col cols="12" md="6" :order="$vuetify.breakpoint.mobile ? 'first': null">
                <v-card-title class="px-0" v-text="host.feature2.title"></v-card-title>
                <v-card-text class="pa-0" v-html="host.feature2.description"></v-card-text>
                </v-col>
              <v-col cols="12" md="6" :order="$vuetify.breakpoint.mobile ? 'last': null">
                <v-img :src="host.feature2.image" contain max-height="400" class="rounded-xl"></v-img>
                </v-col>
              </v-row>
            </v-container>
          </v-sheet>
         <v-card dark tile>
           
            <v-container :style="`max-width:${$config.page.width}px`" class="mx-auto">
              <v-row>
                <v-col cols="12" md="6">
                <v-card-title class="px-0">{{host.name}}</v-card-title>
                <external-link v-if="host._address" v-model="host._address.name" :label="host._address.name" icon="pin_drop" address class="mr-2"></external-link><br>
                <external-link v-model="host.phone" :label="host.phone" icon="support_agent" phone class="mr-2"></external-link>
                </v-col>
              <v-col cols="12" md="6">
                 
              
                 <time-table v-model="host.timetable" card dark></time-table>
              <v-img :src="'/api/print/qr/order/'+ host._id" :width="150" class="my-3"></v-img>
                </v-col>
              
              </v-row>
              
            </v-container>
        </v-card>
        <a name="contact" ref="footer1"></a>
</v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import deliveryCostCard from "@/components/feature/deliveryCostCard.vue";
import discountTable from "@/components/feature/discountTable.vue";
import timeTable from "@/components/feature/timeTable.vue";
import tt from '@/modules/timeTable'
import vStore from "@/components/feature/vStore.vue";
import appPrivacy from "@/components/feature/appPrivacy.vue";
import externalLink from '@/components/externalLink'
export default {
  mixins: [tt],
components: {
    deliveryCostCard,
    discountTable,
    timeTable,vStore,appPrivacy,
    externalLink},
  props: {
    popup: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    host: {
      type: Object,
      default: function () {
        return false
      },
    },
     perma: {
      type: String,
      default: function () {
        return null
      }
    },
  },
  data: () => ({
    expanded: false,
    showCost: false,
    tabindex:-1,
    stamplist: [],
  }),
  computed: {
   ...mapGetters(["user"]),
   actioncode(){
     if (!this.host) return null
     if (this.host._code) return this.host._code
     return {
          name: "Download nu onze app",
          description: this.host.hero || "Download de app om nog sneller te bestellen!",
          stamps: this.host.order ? this.host.order.stampmax : this.$config.stamps.max
     }
   },
   allowHome(){
    let location = window.location.host.toString()
    let perma = (location.split(".")[1] == 'eetplein') ? location.split(".")[0] : null
    if (!perma && !location.includes('eetplein') &&  !location.includes('localhost')) return false
    return true
   },
   allow(){
      return this.allowOrder //!this.opentext.includes('Gesloten voor vandaag')
    },
  },
  mounted(){
   
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style>
.v-application a.btn-google{color:#fff;fill: #fff;}
.btn{padding:10px 16px;margin:5px;font-size:18px;line-height:1.3333333;border-radius:6px;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:1px solid transparent;font-weight:500;text-decoration:none;display:inline-block}
.btn:active:focus,.btn:focus{outline:0}
.btn:focus,.btn:hover{color:#333;text-decoration:none;outline:0}
.btn:active{outline:0;-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}
.btn-google{color:#fff;background-color:#111;border-color:#000;padding:15px 16px 5px 40px;position:relative;font-family:fontfutura;font-weight:600}
.btn-google:focus{color:#fff;background-color:#555;border-color:#000}
.btn-google:active,.btn-google:hover{color:#fff;background-color:#555;border-color:#000;}
.btn-google:not(.btn-apple):before{content:"";background-image:url(https://4.bp.blogspot.com/-52U3eP2JDM4/WSkIT1vbUxI/AAAAAAAArQA/iF1BeARv2To-2FGQU7V6UbNPivuv_lccACLcB/s30/nexus2cee_ic_launcher_play_store_new-1.png);background-size:cover;background-repeat:no-repeat;width:30px;height:30px;position:absolute;left:6px;top:50%;margin-top:-15px}
.btn-google:not(.btn-apple):after{content:"Get it on";position:absolute;top:5px;left:40px;font-size:10px;font-weight:400;}
.btn-google.btn-apple:after{content:"Download on the";position:absolute;top:5px;left:40px;font-size:10px;font-weight:400;}
.btn__icon{
    position: absolute;
    width: 35px;
    margin-left: -37px;
    margin-top: -12px;
}

</style>